import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useIsAdmin } from '@/lib/hooks/use-is-admin';
import { ForbiddenScreen } from '@/components/organisms/forbidden-screen';

function AdminLayout(): ReactElement {
  const isAdmin = useIsAdmin();
  if (!isAdmin) return <ForbiddenScreen />;
  return <Outlet />;
}

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
});
